import React from 'react'
import { Typography, Grid, TextField, Select, MenuItem, InputLabel, FormControl } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { FetchBillDetailsQuery } from '../../../../generated'
import { CardBox, CardBoxTopBar } from '../../../theme/styleComponents'

interface GeneralSectionProps {
  bill?: FetchBillDetailsQuery['fetchBillDetails']['bill']
}

const GeneralSection: React.FC<GeneralSectionProps> = ({ bill }) => {
  return (
    <CardBox my={3}>
      <CardBoxTopBar>
        <Typography variant="h6" fontWeight={400} color="gray900" fontSize="18px">
          General
        </Typography>
      </CardBoxTopBar>

      <Grid container spacing={2} p={3}>
        <Grid item container spacing={2} xs={12} md={6}>
          <Grid item xs={12}>
            <FormControl fullWidth disabled>
              <InputLabel id="matter-title">Matter</InputLabel>
              <Select labelId="matter-title" label="Matter" value={bill?.case?.title || ''}>
                <MenuItem value={bill?.case?.title || ''}>{bill?.case?.title || ''}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <DatePicker
              label="Bill Due Date"
              value={bill?.dueDate ? new Date(bill.dueDate) : null}
              onChange={() => {}}
              disabled
              renderInput={params => <TextField {...params} fullWidth />}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField label="Notes" value={bill?.case?.description || ''} disabled fullWidth multiline rows={4.2} />
        </Grid>
      </Grid>
    </CardBox>
  )
}

export default GeneralSection
